import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmptyDisplayText, hasTooltipItems, formatTooltipLine, buildTooltipItems } from './utils';
export default {
  name: 'DetailTooltip',
  props: {
    text: {
      type: [String, Number],
      default: ''
    },
    /** 详情数据源对象，如 cheat_detail / device_detail */
    dataSource: {
      type: Object,
      default: null
    },
    /**
     * label 与取值字段映射（label 已在常量侧 $t；单位由接口拼好）：
     * [{ label: $t('...'), field: 'altitude' }]
     */
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    emptyText: {
      type: String,
      default: '--'
    },
    emptyValues: {
      type: Array,
      default: function _default() {
        return ['', null, undefined, '--'];
      }
    }
  },
  computed: {
    isEmpty: function isEmpty() {
      return isEmptyDisplayText(this.text, this.emptyValues);
    },
    tooltipItems: function tooltipItems() {
      return buildTooltipItems(this.dataSource, this.fields);
    },
    showTooltip: function showTooltip() {
      return !this.isEmpty && hasTooltipItems(this.tooltipItems);
    },
    formattedLines: function formattedLines() {
      return this.tooltipItems.map(formatTooltipLine);
    }
  }
};